import { render, staticRenderFns } from "./DerFuchs.vue?vue&type=template&id=6a244700&"
var script = {}
import style0 from "./DerFuchs.vue?vue&type=style&index=0&id=6a244700&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports